import Vue from "vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
const PriceSlider = {
  install(Vue, options) {
    Vue.component("PriceSlider", VueSlider);
  },
};
Vue.use(PriceSlider);
